import { CategoryType } from "@core/schema/CategoryType.js";
import type { Country } from "@core/schema/Country.js";
import { countryToIsoCodeMap } from "@core/schema/utils/countryToIsoCodeMap.js";

export const seoFragments = {
	organization: "organization",
	website: "website",
	returnPolicyPerishable: "return-policy-perishable",
	returnPolicyStandard: "return-policy-standard",
} as const;

export function seoId(webUrl: string, fragment: string): string {
	return `${webUrl}/#${fragment}`;
}

export function shippingDetailsId(webUrl: string, country: Country): string {
	return seoId(webUrl, `shipping-${countryToIsoCodeMap[country]}`);
}

export function returnPolicyIdForCategory(webUrl: string, category: CategoryType): string {
	const fragment =
		category === CategoryType.Coffee ? seoFragments.returnPolicyPerishable : seoFragments.returnPolicyStandard;
	return seoId(webUrl, fragment);
}

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
export function idRef<T>(id: string): T {
	return { "@id": id } as T;
}
